import { gerar } from './gerar';
import { pdf } from './pdf';
import { remessa } from './remessa';
import { retorno } from './retorno';

export { defineConfig } from './config';
export { Banco } from './types/Boletos';

export default {
  gerar,
  pdf,
  remessa,
  retorno,
}
